import { http } from "@dashboard/common/http";
import { getEnvVar } from "@dashboard/common/utils";

export const fetchGetFeatureFlag = async (): Promise<boolean> => {
  const language = localStorage.getItem("i18nextLng") || "es";
  const response = await http.get(
    "/api/ms/remote-config/country-data/feature_flag_dashboard",
    {
      headers: {
        "api-key-sumer": getEnvVar("REACT_APP_KEY_SP"),
        "Accept-Language": language,
      },
    }
  );
  if (response.status !== 200) return false;
  return response.data.value.hidde_store_name;
};

export const fetchGetFeatureFlagDomain = async (): Promise<boolean> => {
  const language = localStorage.getItem("i18nextLng") || "es";
  const response = await http.get(
    "/api/ms/remote-config/country-data/feature_flag_dashboard",
    {
      headers: {
        "api-key-sumer": getEnvVar("REACT_APP_KEY_SP"),
        "Accept-Language": language,
      },
    }
  );
  if (response.status !== 200) return false;
  return response.data.value.hidde_domain;
};
